import checkAccess from 'utils/roles/checkAccess';
import getFranchiseRegion from 'utils/jwt/getFranchiseRegion';

export const routerPath = {
  root: '/gym-attendance-reports',
};

export const getColumns = () => [
  {
    id: 'facilityName',
    label: 'Gym',
    align: 'left',
    nameForSort: 'facility_name',
  },
  {
    id: 'region',
    label: 'Region',
    align: 'center',
    nameForSort: 'region',
  },
  {
    id: 'entries',
    label: 'Entries',
    align: 'center',
    nameForSort: 'entries',
  },
  {
    id: 'uniqueEntries',
    label: 'Unique Entries',
    align: 'center',
    nameForSort: 'unique_entries',
  },
  {
    id: 'uniqueUsers',
    label: 'Unique Users',
    align: 'center',
    nameForSort: 'unique_users',
  },
  {
    id: 'avgPerUserVisit',
    label: 'Average Visit Per User',
    align: 'center',
    nameForSort: 'average_visit_per_user',
  },
];

export const getFilters = ({ region, gym, dateRange, options }) => [
  {
    id: 'gym',
    type: 'select',
    label: 'Gym',
    value: gym.value,
    action: gym.change,
    items: options?.gyms?.length ? ['all', ...options.gyms.map((item) => item.name)] : ['all'],
  },
  {
    id: 'dateRange',
    variant: 'date',
    type: 'dateRange',
    value: dateRange.value,
    action: dateRange.change,
  },
  {
    id: 'region',
    type: 'select',
    label: 'Region',
    value: checkAccess([2]) ? getFranchiseRegion() : region.value,
    action: region.change,
    items: options?.regions?.length ? ['all', ...options.regions] : ['all'],
    disabledEdit: checkAccess([2]),
  },
];
